var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    getEvents: {
        loading: false,
        events: [],
    },
    getMessages: {
        loading: false,
    },
    getMessageThread: {
        loading: false,
    },
    replyToThread: {
        loading: false,
        success: false,
    },
    totalMessageCount: 0,
};
export var messageThreadSlice = createSlice({
    name: 'messages',
    initialState: initialState,
    reducers: {
        clearMessages: function (state) {
            state.messageThread = undefined;
            state.records = undefined;
        },
        getMessageThreadRequested: function (state, action) {
            state.getMessageThread.loading = true;
            state.getMessageThread.error = undefined;
        },
        getMessageThreadFailed: function (state, action) {
            state.getMessageThread.loading = false;
            state.getMessageThread.error = action.payload;
        },
        getMessageThreadSuceeded: function (state, action) {
            var _a;
            state.getMessageThread.loading = false;
            state.messageThread = action.payload;
            state.records = (_a = state.messageThread) === null || _a === void 0 ? void 0 : _a.messages;
        },
        markMessageAsReadRequested: function (state, action) {
            // NOOP
        },
        markMessageAsReadSucceeded: function (state, action) {
            action.payload.messageIds.forEach(function (id) {
                var index = state.records.findIndex(function (message) { return message.id === id; });
                state.records[index].isRead = true;
            });
        },
        replyToThreadRequested: function (state, action) {
            state.replyToThread.loading = true;
            state.replyToThread.success = false;
            state.replyToThread.error = undefined;
        },
        replyToThreadSucceeded: function (state, action) {
            state.replyToThread.loading = false;
            state.replyToThread.success = true;
            state.replyToThread.error = undefined;
            state.records = __spreadArray([action.payload], state.records, true);
        },
        replyToThreadFailed: function (state, action) {
            state.replyToThread.loading = false;
            state.replyToThread.success = false;
            state.replyToThread.error = action.payload;
        },
        getMessagesRequested: function (state, action) {
            state.getMessages.loading = false;
            state.getMessages.error = undefined;
        },
        getMessagesFailed: function (state, action) {
            state.getMessages.loading = false;
            state.getMessages.error = action.payload;
        },
        getMessagesSucceeded: function (state, action) {
            state.getMessages.loading = false;
            state.records = action.payload.content;
        },
        getNotificationsRequested: function (state) {
            state.getEvents.loading = true;
        },
        getNotificationsSucceeded: function (state, action) {
            state.getEvents.loading = false;
            state.getEvents.events = action.payload.results;
        },
        getNotificationsFailed: function (state, action) {
            // NOOP
        },
        markNotificationsAsReadRequested: function (state, action) {
            // NOOP
        },
    },
});
export var clearMessages = (_a = messageThreadSlice.actions, _a.clearMessages), markMessageAsReadRequested = _a.markMessageAsReadRequested, markMessageAsReadSucceeded = _a.markMessageAsReadSucceeded, replyToThreadRequested = _a.replyToThreadRequested, replyToThreadSucceeded = _a.replyToThreadSucceeded, replyToThreadFailed = _a.replyToThreadFailed, getMessageThreadRequested = _a.getMessageThreadRequested, getMessageThreadFailed = _a.getMessageThreadFailed, getMessageThreadSuceeded = _a.getMessageThreadSuceeded, getMessagesRequested = _a.getMessagesRequested, getMessagesFailed = _a.getMessagesFailed, getMessagesSucceeded = _a.getMessagesSucceeded, markNotificationsAsReadRequested = _a.markNotificationsAsReadRequested, getNotificationsFailed = _a.getNotificationsFailed, getNotificationsRequested = _a.getNotificationsRequested, getNotificationsSucceeded = _a.getNotificationsSucceeded;
export default messageThreadSlice.reducer;
